module.exports = __webpack_public_path__ + "static/img/Gasly.8692351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Gasly.jpg
// module id = HV5S
// module chunks = 1